/**
 *
 * @param {String} party
 */

const $settings = window.appSettings;

const paintOptions = function(party, settings = {}) {
  const color = (() =>
    $settings.partyColors[party.toUpperCase()] ||
    $settings.partyColors.default)();
  if (settings.activeColor) {
    return color.replace("0.4", "1");
  }
  return color;
};

const provinceSettings = {
  501: {
    name: "Groningen",
    code: 501,
    color: "#3984b5",
    mapComponent: "Groningen",
    logo: $settings.provinceLogo.groningen,
    key: "GR"
  },
  502: {
    name: "Friesland",
    code: 502,
    color: "#3984b5",
    mapComponent: "Friesland",
    logo: $settings.provinceLogo.friesland,
    key: "FR"
  },
  503: {
    name: "Drenthe",
    code: 503,
    color: "#3984b5",
    mapComponent: "Drenthe",
    logo: $settings.provinceLogo.drenthe,
    key: "DR"
  },
  504: {
    name: "Overijssel",
    code: 504,
    color: "#3984b5",
    mapComponent: "Overijssel",
    logo: $settings.provinceLogo.overijssel,
    key: "OV"
  },
  505: {
    name: "Flevoland",
    code: 505,
    color: "#3984b5",
    mapComponent: "Flevoland",
    logo: $settings.provinceLogo.flevoland,
    key: "FL"
  },
  506: {
    name: "Gelderland",
    code: 506,
    color: "#3984b5",
    mapComponent: "Gelderland",
    logo: $settings.provinceLogo.gelderland,
    key: "GE"
  },
  507: {
    name: "Utrecht",
    color: "#3984b5",
    code: 507,
    mapComponent: "Utrecht",
    key: "UT",
    logo: $settings.provinceLogo.utrecht
  },
  508: {
    name: "Noord Holland",
    code: 508,
    color: "#288fdf",
    mapComponent: "NoordHolland",
    logo: $settings.provinceLogo.noordHolland,
    key: "NH"
  },
  509: {
    name: "Zuid Holland",
    code: 509,
    color: "#3984b5",
    mapComponent: "ZuidHolland",
    logo: $settings.provinceLogo.zuidHolland,
    key: "ZH"
  },
  510: {
    name: "Zeeland",
    code: 510,
    color: "#3984b5",
    mapComponent: "Zeeland",
    logo: $settings.provinceLogo.zeeland,
    key: "ZE"
  },
  511: {
    name: "Noord Brabant",
    code: 511,
    color: "#3984b5",
    mapComponent: "NoordBrabant",
    key: "NB",
    logo: $settings.provinceLogo.noordBrabant
  },
  512: {
    name: "Limburg",
    code: 512,
    color: "#3984b5",
    mapComponent: "Limburg",
    logo: $settings.provinceLogo.limburg,
    key: "LI"
  }
};

const domainPreferences = (function() {
  const url = window.location.href;
  const domainCode = Object.entries($settings.domainPreferences).find(
    ([match]) => url.match(match)
  );
  return domainCode ? domainCode[1] : "507"; // 507 is Utrecht which is the default for now
})();

const electionYear = $settings.electionYear;

export { paintOptions, domainPreferences, provinceSettings, electionYear };
